import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['Drills scattered across videos, in no order', 'Blank templates you still have to fill in', 'One level, so someone always gets left out', 'Nothing printable to take on court', 'You still rebuild every session yourself'];
const withIt = ['77 sessions written out, block by block', 'A season-long progression, grip to match play', 'A 3-Level Dial in every drill', 'Session sheets, drill cards and worksheets to print', "Open it the night before and you're done"];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-white" data-id="element-345" data-mp="297qq1ic6p24k">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-346" data-mp="295e6j0qs2jpe">
        <div className="text-center" data-id="element-347" data-mp="2d798m7gj9148">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-court" data-id="element-348" data-mp="30yeogmmh3tej">
            Why this isn&apos;t another drill library
          </p>
          <h2 id="vs-heading" className="mt-3 font-display font-bold text-ink text-[28px] leading-tight tracking-tight sm:text-5xl" data-id="element-349" data-mp="35pwn3410xhwc">
            Scattered drills vs{' '}
            <span className="text-court" data-id="element-350" data-mp="1ohuz63zlil3h">a planned season</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-351" data-mp="2367ucyquzzwx">
            Badminton drills are everywhere. What&apos;s missing is knowing
            which ones to run, in what order, for the group in front of you this
            week.
          </p>
        </div>

        {/* Two columns at every width — never stacks */}
        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-2xl border border-line shadow-card" data-id="element-352" data-mp="283zj5jw7j5ww">
          <div className="bg-light px-3.5 py-4 sm:p-6" data-id="element-353" data-mp="2m1xwclyskwat">
            <h3 className="font-display text-[15px] font-bold leading-tight text-ink-soft sm:text-xl" data-id="element-354" data-mp="2h5z5mrpzr278">
              Free videos &amp; templates
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-355" data-mp="mqwmdbrjcgcr">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-ink-soft sm:text-sm" data-id="element-356" data-mp="2mt5u0sr006sj">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-coral/15" data-id="element-357" data-mp="2rsiqm57o8s8b">
                    <XIcon className="h-2.5 w-2.5 text-coral-deep" aria-hidden="true" data-id="element-358" data-mp="2vw6yyq44nrum" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-court px-3.5 py-4 text-white sm:p-6" data-id="element-359" data-mp="3ar4ufrukoxfx">
            <h3 className="font-display text-[15px] font-bold leading-tight text-shuttle sm:text-xl" data-id="element-360" data-mp="3apa7k7zqqv97">
              Badminton Class Ready
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-361" data-mp="3jjyahrhug0uu">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-medium leading-snug sm:text-sm" data-id="element-362" data-mp="3oirnlit7xpuh">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-green" data-id="element-363" data-mp="3tf9ryhkmzm6a">
                    <CheckIcon className="h-2.5 w-2.5 text-white" aria-hidden="true" data-id="element-364" data-mp="2h2b4be03eld" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}